export const computedStyle = (element) => (
	element.currentStyle
		? element.currentStyle
		: window.getComputedStyle(element)
);

export default computedStyle;
